import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import StudentForm from "./StudentForm";
import EstablishmentprofileData from "../../../components/rh/establishmentprofiles/EstablishmentprofileData";
import Listprint from "../../Listprint";
import EstabsectschoolfeecatstudcategoryForm from "./EstabsectschoolfeecatstudcategoryForm";

class Student extends Component {
    state = {
        isModal: false, isModalProfile: false, isModalCategory: false,
        user: "", userestablishprofile: "", formData: "", displayArray: [],
        students: [], classe: "", loading: true, loadError: false,
        columns: [
            { label: "Matricule", field: "matricule", sort: "asc", width: 90 },
            { label: "Élève", field: "student", sort: "asc", width: 220 },
            { label: "Responsable", field: "responsible", sort: "asc", width: 180 },
            { label: "Genre", field: "genre", sort: "asc", width: 90 },
            { label: "Statut", field: "status", sort: "asc", width: 90 },
            { label: "Année", field: "year", sort: "asc", width: 90 },
            { label: "Inscription", field: "created_at", sort: "asc", width: 110 },
            { label: "Actions", field: "action", sort: "disabled", width: 110, printable: false }
        ]
    };

    componentDidMount() { this.getStudents(); }

    getStudents = async () => {
        this.setState({ loading: true, loadError: false });
        try {
            const response = await axios.get("students");
            const students = response.status === 200 && Array.isArray(response.data) ? response.data : [];
            const sectionIds = [...new Set(students.map((student) => student.sectionclass?.section?.id).filter(Boolean))];
            this.setState((state) => ({
                students, loading: false,
                // displayArray: state.displayArray.length ? state.displayArray.filter((id) => sectionIds.includes(id)) : sectionIds.slice(0, 1)
                displayArray: state.displayArray.length ? state.displayArray.filter((id) => sectionIds.includes(id)) : []
            }));
        } catch (error) { this.setState({ loading: false, loadError: true }); }
    };

    showModal = (student = null, classe = false, operation = false) => {
        if (operation === 1) this.getStudents();
        this.setState((state) => ({ isModal: !state.isModal, formData: student, classe: classe ? student : null }));
    };

    delete = (studentId) => {
        if (!window.confirm("Supprimer définitivement cet élève ?")) return;
        axios.delete(`students/${studentId}`).then((response) => {
            this.getStudents();
            toast(response?.data?.msg, { theme: "light", style: { backgroundColor: "blue", color: "white" } });
        }).catch((error) => toast(error.response?.data?.msg, { theme: "light", style: { backgroundColor: "red", color: "white" } }));
    };

    showModalProfile = (userestablishprofile = null, user = null) => {
        this.setState((state) => ({ isModalProfile: !state.isModalProfile, userestablishprofile, user }));
        this.getStudents();
    };

    showModalCategory = (student = null) => {
        this.setState((state) => ({ isModalCategory: !state.isModalCategory, formData: student }));
        this.getStudents();
    };

    checkArray = (sectionId) => this.setState((state) => ({
        displayArray: state.displayArray.includes(sectionId) ? state.displayArray.filter((id) => id !== sectionId) : [...state.displayArray, sectionId]
    }));

    toggleAllSections = (sectionIds) => this.setState((state) => ({
        displayArray: state.displayArray.length === sectionIds.length ? [] : sectionIds
    }));

    handleExport = (classe = null, data = []) => {
        const jsonData = data.map((student) => ({
            matricule: student.user ? student.matricule : "",
            lastName: student.user?.last_name || "", familyName: student.user?.family_name || "", firstName: student.user?.first_name || "",
            responsibleLast: `${student?.user?.user?.first_name || ""} ${student?.user?.user?.last_name || ""}`.trim(),
            responsibleFamily: student?.user?.user?.family_name || "", staffStudent: student.staff_student,
            genre: student.user?.genre || "", year: student.year?.year || "",
            status: student.status === 1 ? "Actif" : student.status === 0 ? "Abandon" : "Non actif",
            createdAt: student.createdAt ? new Date(student.createdAt).toLocaleDateString("fr-FR") : ""
        }));
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Élèves");
        XLSX.writeFile(workbook, `eleves_${classe}_${new Date().toLocaleDateString("fr-FR").replaceAll("/", "-")}.xlsx`);
    };

    handleCheck = (permission) => {
        const permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some((item) => permission === item.permission);
    };

    getSections = () => {
        const sections = new Map();
        this.state.students.forEach((student) => {
            const sectionClass = student.sectionclass;
            const section = sectionClass?.section;
            if (!section?.id || !sectionClass?.id) return;
            if (!sections.has(section.id)) sections.set(section.id, { section, classes: new Map() });
            const group = sections.get(section.id);
            if (!group.classes.has(sectionClass.id)) group.classes.set(sectionClass.id, { sectionClass, students: [] });
            group.classes.get(sectionClass.id).students.push(student);
        });
        return [...sections.values()]
            .sort((a, b) => (a.section.entitled_section || "").localeCompare(b.section.entitled_section || ""))
            .map((group) => ({ ...group, classes: [...group.classes.values()].sort((a, b) => {
                const aLabel = `${a.sectionClass.class?.short_entitled_class || ""} ${a.sectionClass.title || ""}`;
                const bLabel = `${b.sectionClass.class?.short_entitled_class || ""} ${b.sectionClass.title || ""}`;
                return aLabel.localeCompare(bLabel, "fr", { numeric: true });
            }) }));
    };

    getStatusBadge = (status) => {
        if (status === 1) return <span className="student-status student-status--active">Actif</span>;
        if (status === 0) return <span className="student-status student-status--success">Archivé</span>;
        if (status === -1) return <span className="student-status student-status--danger">Abandon</span>;
        if (status === 2) return <span className="student-status student-status--warning">Non actif</span>;

        return <span className="student-status student-status--muted">Non actif</span>;
    };

    getRows = (students) => students?.sort((a, b) =>
        a.user?.last_name?.localeCompare(b.user?.last_name, "fr", { numeric: true }) ||
        a.user?.family_name?.localeCompare(b.user?.family_name, "fr", { numeric: true })
        )?.map((student) => {
        const fullName = [student.user?.last_name, student.user?.family_name, student.user?.first_name].filter(Boolean).join(" ");
        const responsible = [student?.user?.user?.first_name, student?.user?.user?.last_name, student?.user?.user?.family_name].filter(Boolean).join(" ");
        return {
            id: student.id,
            matricule: student.user ? <Link to={`/students/${student.id}`} className="student-matricule">{student.matricule}</Link> : "—",
            student: fullName || "Nom non renseigné", responsible: responsible || "—", genre: student.user?.genre || "—",
            year: student.year?.year || "—", status: this.getStatusBadge(student.status),
            created_at: student.createdAt ? new Date(student.createdAt).toLocaleDateString("fr-FR") : "—",
            action: <span className="student-row-actions">
                {this.handleCheck("Modifier élève") && <button type="button" onClick={() => this.showModal(student)} className="student-icon-button" title="Modifier l’élève" aria-label="Modifier l’élève"><FeatherIcon icon="edit-3" size="15" /></button>}
                {this.handleCheck("Afficher élève") && <Link to={`/studentfile/${student.id}`} className="student-icon-button" title="Ouvrir le dossier" aria-label="Ouvrir le dossier de l’élève"><FeatherIcon icon="file-text" size="15" /></Link>}
                {this.handleCheck("Supprimer élève") && <button type="button" onClick={() => this.delete(student.id)} className="student-icon-button student-icon-button--danger" title="Supprimer l’élève" aria-label="Supprimer l’élève"><FeatherIcon icon="trash-2" size="15" /></button>}
            </span>
        };
    });

    renderClass = ({ sectionClass, students }, section) => {
        const className = `${sectionClass.class?.short_entitled_class || ""} ${sectionClass.title || ""}`.trim();
        const exportTitle = `${className} ${section.entitled_section || ""}`.trim();
        return <article className="student-class-card" key={sectionClass.id}>
            <div className="student-class-card__header">
                <div className="student-class-card__title"><span className="student-class-card__icon"><FeatherIcon icon="book-open" size="18" /></span><div><h3>{className || "Classe"}</h3><span>{students.length} {students.length > 1 ? "élèves" : "élève"}</span></div></div>
                <div className="student-class-card__actions">
                    {this.handleCheck("Ajouter élève") && <button type="button" className="btn btn-sm btn-primary" onClick={() => this.showModal(sectionClass.id, true)}><FeatherIcon icon="user-plus" size="16" /> Ajouter</button>}
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => this.handleExport(exportTitle, students)} type="button"><FeatherIcon icon="download" size="16" /> Excel</button>
                </div>
            </div>
            <div className="student-class-card__table"><Listprint columns={this.state.columns} rows={this.getRows(students)} title={`Élèves de ${className} — ${section.short_entitled_section || section.entitled_section}`} /></div>
        </article>;
    };

    render() {
        const sectionGroups = this.getSections();
        const sectionIds = sectionGroups.map(({ section }) => section.id);
        const activeStudents = this.state.students.filter((student) => student.status === 1).length;
        const inactiveStudents = this.state.students.length - activeStudents;
        return <main className="students-page">
            <Helmet><title>{process.env.REACT_APP_NAME} | Élèves</title></Helmet>
            <header className="students-hero">
                <div className="students-hero__content"><span className="students-hero__eyebrow">Gestion scolaire</span><h1>Élèves</h1><p>Consultez les effectifs, gérez les dossiers et exportez les listes par classe.</p></div>
                <div className="students-hero__actions">
                    <Link to="/manuel#students" className="btn students-hero__guide" title="Consulter le guide d’utilisation de la page Élèves"><FeatherIcon icon="book-open" size="18" /> Guide d’utilisation</Link>
                    {this.handleCheck("Ajouter élève") && <button type="button" className="btn btn-primary students-hero__action" onClick={() => this.showModal(null, true)}><FeatherIcon icon="user-plus" size="18" /> Nouvel élève</button>}
                </div>
            </header>

            {!this.state.loading && !this.state.loadError && <section className="students-stats" aria-label="Résumé des effectifs">
                <article className="students-stat"><span className="students-stat__icon"><FeatherIcon icon="users" size="20" /></span><div><strong>{this.state.students.length}</strong><span>Élèves inscrits</span></div></article>
                <article className="students-stat"><span className="students-stat__icon students-stat__icon--success"><FeatherIcon icon="user-check" size="20" /></span><div><strong>{activeStudents}</strong><span>Élèves actifs</span></div></article>
                <article className="students-stat"><span className="students-stat__icon students-stat__icon--warning"><FeatherIcon icon="user-x" size="20" /></span><div><strong>{inactiveStudents}</strong><span>Non actifs / abandons</span></div></article>
                <article className="students-stat"><span className="students-stat__icon students-stat__icon--purple"><FeatherIcon icon="layers" size="20" /></span><div><strong>{sectionGroups.length}</strong><span>Sections représentées</span></div></article>
            </section>}

            {this.state.loading && <div className="students-feedback"><FeatherIcon className="user-search-spin" icon="loader" /></div>}
            {!this.state.loading && this.state.loadError && <div className="students-feedback students-feedback--error"><FeatherIcon icon="alert-circle" size="30" /><h2>Impossible de charger les élèves</h2><p>Vérifiez votre connexion puis réessayez.</p><button type="button" className="btn btn-primary btn-sm" onClick={this.getStudents}><FeatherIcon icon="refresh-cw" size="15" /> Réessayer</button></div>}
            {!this.state.loading && !this.state.loadError && sectionGroups.length === 0 && <div className="students-feedback"><span className="students-feedback__icon"><FeatherIcon icon="users" size="32" /></span><h2>Aucun élève pour le moment</h2><p>Ajoutez un premier élève pour commencer à constituer vos classes.</p>{this.handleCheck("Ajouter élève") && <button type="button" className="btn btn-primary btn-sm" onClick={() => this.showModal(null, true)}><FeatherIcon icon="user-plus" size="15" /> Ajouter un élève</button>}</div>}

            {!this.state.loading && !this.state.loadError && sectionGroups.length > 0 && <section className="students-sections">
                <div className="students-sections__heading"><div><span>Organisation</span><h2>Effectifs par section</h2></div><button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleAllSections(sectionIds)}><FeatherIcon icon={this.state.displayArray.length === sectionIds.length ? "chevrons-up" : "chevrons-down"} size="16" />{this.state.displayArray.length === sectionIds.length ? "Tout replier" : "Tout déplier"}</button></div>
                {sectionGroups.map(({ section, classes }) => {
                    const isOpen = this.state.displayArray.includes(section.id);
                    const sectionTotal = classes.reduce((total, item) => total + item.students.length, 0);
                    return <article className={`student-section ${isOpen ? "is-open" : ""}`} key={section.id}>
                        <button type="button" className="student-section__toggle" onClick={() => this.checkArray(section.id)} aria-expanded={isOpen}><span className="student-section__badge">{section.short_entitled_section || "Section"}</span><span className="student-section__name"><strong>{section.entitled_section}</strong><small>{classes.length} {classes.length > 1 ? "classes" : "classe"} · {sectionTotal} {sectionTotal > 1 ? "élèves" : "élève"}</small></span><span className="student-section__chevron"><FeatherIcon icon="chevron-down" size="20" /></span></button>
                        {isOpen && <div className="student-section__content">{classes.map((classGroup) => this.renderClass(classGroup, section))}</div>}
                    </article>;
                })}
            </section>}

            {this.state.isModal && <StudentForm isModal={this.state.isModal} formData={this.state.formData} classe={this.state.classe} matricule={(this.state.students.length + 1)+"" + (this.state.students[0]?.year?.id || '')} showModal={this.showModal} />}
            {this.state.isModalCategory && <EstabsectschoolfeecatstudcategoryForm isModal={this.state.isModalCategory} formData={this.state.formData} classe={this.state.classe} showModal={this.showModalCategory} />}
            {this.state.isModalProfile && <EstablishmentprofileData isModal={this.state.isModalProfile} formData={this.state.userestablishprofile} fromUser={this.state.user} showModal={this.showModalProfile} />}
        </main>;
    }
}

export default Student;
